export const SYNC_DATA_VERSION = 2;
export function validateWord(value: any): void {
  if (!value || typeof value !== "object" || Array.isArray(value) ||
    !Number.isSafeInteger(value.id) || value.id <= 0 || (value.word_id !== undefined && value.word_id !== value.id) ||
    !Number.isSafeInteger(value.dictionary_id) || value.dictionary_id <= 0 ||
    typeof value.word !== "string" || !value.word.trim() || typeof value.language_code !== "string" || !value.language_code)
    throw Error("Invalid vocabulary record");
  for (const key of ["translations", "phonetics_map"]) {
    const map = value[key];
    if (map !== undefined && (!map || typeof map !== "object" || Array.isArray(map) || Object.values(map).some(v => typeof v !== "string")))
      throw Error("Invalid vocabulary descriptors");
  }
  for (const key of ["translation", "transcription", "phonetics", "hint", "short_word"])
    if (value[key] !== undefined && typeof value[key] !== "string") throw Error("Invalid vocabulary text");
  if (value.stars !== undefined && (!Number.isInteger(value.stars) || value.stars < 0 || value.stars > 5)) throw Error("Invalid progress");
}
export function validateSnapshotPage(page: any, offset: number, previous?: any): void {
  if (page?.sync_protocol !== 2 || typeof page.snapshot_id !== "string" || !page.snapshot_id ||
      typeof page.word_cursor !== "string" || !/^w1\.[^.]+\.[^.]+\.\d+$/.test(page.word_cursor) ||
      !Array.isArray(page.words) || !Number.isSafeInteger(page.total_words) || page.total_words < 0 ||
      page.next_offset !== offset + page.words.length || page.has_more !== (page.next_offset < page.total_words) ||
      page.next_offset > page.total_words || (page.has_more && !page.words.length) ||
      !page.preferences || typeof page.preferences !== "object" || Array.isArray(page.preferences) ||
      !page.catalogs || typeof page.catalogs !== "object" || Array.isArray(page.catalogs) ||
      (previous && (page.snapshot_id !== previous.snapshot_id || page.word_cursor !== previous.word_cursor || page.total_words !== previous.total_words)))
    throw Error("Invalid or incomplete vocabulary snapshot");
  page.words.forEach(validateWord);
}
export function validateDeltaPage(page: any, before: string): void {
  const prefix = before.slice(0,before.lastIndexOf('.')+1);
  if (page?.sync_protocol !== 2 || typeof page.word_cursor !== "string" ||
      !page.word_cursor.startsWith(prefix) || !/^w1\.[^.]+\.[^.]+\.\d+$/.test(page.word_cursor) ||
      BigInt(page.word_cursor.slice(prefix.length)) < BigInt(before.slice(prefix.length)) ||
      !Array.isArray(page.changes) || typeof page.has_more !== "boolean" ||
      (page.has_more && (!page.changes.length || page.word_cursor === before))) throw Error("Invalid vocabulary changes");
}
